import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  static targets = ["tabs", "tab", "panel"];

  close(event) {
    event?.preventDefault();
    this.element.close();
  }

  selectTab(event) {
    this.activate(event.currentTarget.dataset.tab, { focus: false });
  }

  navigateTabs(event) {
    const allowedKeys = ["ArrowLeft", "ArrowRight", "Home", "End"];
    if (!allowedKeys.includes(event.key)) return;

    event.preventDefault();
    const currentIndex = this.tabTargets.indexOf(event.currentTarget);
    let nextIndex = currentIndex;
    if (event.key === "Home") nextIndex = 0;
    if (event.key === "End") nextIndex = this.tabTargets.length - 1;
    if (event.key === "ArrowRight") nextIndex = (currentIndex + 1) % this.tabTargets.length;
    if (event.key === "ArrowLeft") nextIndex = (currentIndex - 1 + this.tabTargets.length) % this.tabTargets.length;
    this.activate(this.tabTargets[nextIndex].dataset.tab, { focus: true });
  }

  activate(selected, { focus }) {
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tab === selected;
      tab.setAttribute("aria-selected", active.toString());
      tab.tabIndex = active ? 0 : -1;
      if (active && focus) tab.focus();
    });
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.tabPanel !== selected;
    });
    this.tabsTarget.dataset.selectedTab = selected;
  }

  targetSelection(event) {
    const submit = event.target.closest("[data-dialog-fields]")?.querySelector("[data-selection-submit]");
    if (submit) submit.disabled = event.detail.count === 0;
  }
}
